<script lang="ts">
  import { SortOption } from "../_helper/product-manager";
  export let sortDirections: (value: string) => void = () => {};
  export let className = "";

  let toggleSort = false;
  function toggleSortFn(ev: Event) {
    ev.preventDefault();
    toggleSort = !toggleSort;
  }

  function getValue(value: string) {
    sortDirections(value);
  }
</script>

<section class={`sort ${className}`} on:click={ev => toggleSortFn(ev)} on:keyup={() => {}} role="button" tabindex="0">
  <h2 class="pf-400">Sort by price <i class:active={toggleSort} /></h2>
  <div class:active={toggleSort}>
    {#each Object.entries(SortOption) as item}
      <button on:click={ev => getValue(item[1])}>{item[0].replaceAll("_", " ").toLowerCase()}</button>
    {/each}
  </div>
</section>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .sort {
    margin: 0;
    position: relative;
    h2 {
      font-size: 16px;
      margin: 0;
      i {
        display: inline-block;
        width: 12px;
        height: 10px;
        background-image: url("../_assets/arrow-dark.svg");
        background-position: center;
        background-repeat: no-repeat;
        transform: rotate(90deg);
      }
      i.active {
        transform: rotate(270deg);
      }
    }
    div {
      position: absolute;
      height: 0;
      overflow: hidden;
      transition: all 0.4sec ease-in-out;
      button {
        background: none;
        border: none;
        color: #000;
        text-transform: capitalize;
        padding: 0.3em;
      }
      button:hover {
        background: #f2f2f2;
      }
    }
    div.active {
      overflow: unset;
      width: 10em;
      height: unset;
      padding: 1em;
      margin-top: 0.5em;
      background: #fff;
      z-index: var(--z1);
      border: 1px solid grey;
      border-radius: 1em;
      right: 0;
      @include desktop {
        right: unset;
      }
    }
  }
</style>
